import api from "./axiosAPI";

export const analyticsAPI = {
    getData: (
        page,
        pageSize,
        filters = {},
        groupBy = null,
        annotations = null,
        ordering = null
    ) => {
        const params = new URLSearchParams();
        if (page !== undefined && page !== null) {
            params.append("page", page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            params.append("page_size", pageSize);
        }
        if (filters && Object.keys(filters).length > 0) {
            params.append("filters", JSON.stringify(filters));
        }
        if (Array.isArray(groupBy) && groupBy.length > 0) {
            params.append("group_by", JSON.stringify(groupBy));
        } else if (groupBy) {
            params.append("group_by", groupBy);
        }
        if (annotations) {
            params.append("annotations", JSON.stringify(annotations));
        }
        if (ordering) {
            params.append("ordering", ordering);
        }

        const query = params.toString();
        const url = query ? `analytics/orders/?${query}` : "analytics/orders/";
        return api.get(url);
    },

    getFilters: () => {
        return api.get(`analytics/orders/filters/`);
    },

    getAnnotations: (grouping = null) => {
        const params = new URLSearchParams();
        if (Array.isArray(grouping) && grouping.length > 0) {
            params.append("grouping", JSON.stringify(grouping));
        } else if (grouping) {
            params.append("grouping", grouping);
        }
        const query = params.toString();
        const url = query ? `analytics/orders/annotations/?${query}` : "analytics/orders/annotations/";
        return api.get(url);
    },

    getGroupOptions: () => {
        return api.get(`analytics/orders/group-options/`);
    },

    getOrderingOptions: () => {
        return api.get(`analytics/orders/ordering-options/`);
    },
};
